module.exports = "<p>\n  footer works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/shared/footer/footer.component.html
// module id = ../../../../../src/app/components/shared/footer/footer.component.html
// module chunks = 1